import React from "react";
import img404 from "../assets/pagenotfound.png";
import { Container } from "@mui/material";


export const NotFound = () => {
  return (
    <Container className="notfound">
      <img src={img404} alt="404" width="100%" />
    </Container>
  );
};